export const baseMarketMetadata = {
  companyName: 'Bemlo',
  employerId: 'bemlo',
  logoUrl:
    'https://images.ctfassets.net/ldkigls6axrl/3aoieFYHqPjIa2tt1t7Pjs/f7c6b3b25ec80bf87d0057f26cbb6a73/Untitled-1.jpg?w=1000&q=50',
  siteName: 'Bemlo',
  siteShortName: 'Bemlo',
}
